(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  /*
    Clamps the long copy to --collapsed-height and shows the toggle only when the text is
    taller than that. Without JavaScript the full text simply shows.
  */
  class CollectionDescriptionCopy extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.collection-description__copy-text');
      this.button = this.querySelector('.collection-description__toggle');
      if (!this.text || !this.button) return;

      const collapsed = parseFloat(getComputedStyle(this).getPropertyValue('--collapsed-height')) || 0;
      if (this.text.scrollHeight <= collapsed + 24) return;

      this.dataset.collapsed = '';
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!expanded));
      this.button.textContent = expanded ? this.button.dataset.showMore : this.button.dataset.showLess;
      if (expanded) {
        this.dataset.collapsed = '';
        this.scrollIntoView({ block: 'nearest' });
      } else {
        delete this.dataset.collapsed;
      }
    }
  }

  if (!customElements.get('collection-description-copy')) {
    customElements.define('collection-description-copy', CollectionDescriptionCopy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
